module.exports = __webpack_public_path__ + "img/app_new_guest.3c174201.svg";